import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { FilteringService } from 'src/app/services/filtering.service';
import { RMO_ClientMapping, RMO_ClientMeta } from './models/rentManager';
import { YardiClientMapping } from './models/yardi';
import { IntegrationsService } from './services/integrations.service';
import { tap } from 'rxjs/internal/operators/tap';
import { IntegrationProvider } from './models/integrationModels';

@Component({
  selector: 'app-integrations',
  templateUrl: './integrations.component.html',
  styleUrls: ['./integrations.component.less']
})
export class IntegrationsComponent implements OnInit, OnDestroy {

  @Input() riqClientId: number;

  constructor(public modalService: NgbModal, public integrations: IntegrationsService, public toast: ToastrService, public filtering: FilteringService) { }
  ngOnDestroy(): void {
  }

  ngOnInit() {

  }
}
